import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import CurrencyRang from './CurrencyRang.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Currency,
    widget: 'CurrencyRang',
    multi: false
  })
)
export class FormMoneyCurrencyRangFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(CurrencyRang);
    return this;
  }

  @Widget.Reactive()
  _formData: any = {};

  @Widget.Watch('formData', { deep: true, immediate: true })
  watchFormData(val) {
    this._formData = val;
  }
}
